import { render, staticRenderFns } from "./SupplierTabsNotes.vue?vue&type=template&id=4a5f9a70&scoped=true&"
import script from "./SupplierTabsNotes.vue?vue&type=script&lang=js&"
export * from "./SupplierTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f9a70",
  null
  
)

export default component.exports